import { BannerService } from 'sat-core';

import gwLogoSmall from '../img/gw-logo-sm.png';

BannerService.generateFooterLinkMap = () => {
  return new Map([
    ['termsOfUse', 'https://www.g-w.com/terms'],
    ['privacy', 'https://www.g-w.com/privacy'],
    ['support', 'https://support.g-w.com/home']
  ]);
};

BannerService.getLogoInfo = () => {
  return {
    logoImg: gwLogoSmall,
    logoUrl: 'https://www.g-w.com/'
  };
};
